var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSalesforce = function SvgSalesforce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.833 11.667a4.999 4.999 0 0 1 2.613-4.395 5.002 5.002 0 0 1 9.642-.489l.092-.03c.256-.046.617-.086.987-.086a5 5 0 0 1 0 10H5.833a5 5 0 0 1-5-5Zm11.138-2.932L11.504 7.3a3.335 3.335 0 0 0-6.429.324l-.161.747-.671.365A3.333 3.333 0 0 0 5.833 15h8.334a3.333 3.333 0 1 0-.72-6.589l-1.476.324Z",
    fill: "#fff"
  })));
};

export default SvgSalesforce;